export const THDTypographyStyles = {
    root: {
        htmlFontSize: 16,
    },
    h1: {
        fontSize: '6rem',
        fontWeight: 700,
        fontFamily: 'helvetica-neue-bold,Helvetica Neue,Helvetica,Arial,sans-serif',
    },
    h2: {
        fontSize: '3.75rem',
        fontWeight: 700,
        fontFamily: 'helvetica-neue-bold,Helvetica Neue,Helvetica,Arial,sans-serif',
    },
    h3: {
        fontsize: '3rem',
        fontWeight: 700,
        fontFamily: 'helvetica-neue-bold,Helvetica Neue,Helvetica,Arial,sans-serif',
    },
    h4: {
        fontSize: '2.125rem',
        fontWeight: 700,
        fontFamily: 'helvetica-neue-bold,Helvetica Neue,Helvetica,Arial,sans-serif',
    },
    h5: {
        fontSize: '1.5rem',
        fontWeight: 400,
        fontFamily: 'helvetica-neue-bold,Helvetica Neue,Helvetica,Arial,sans-serif',
    },
    h6: {
        fontSize: '1.25rem',
        fontWeight: 700,
        fontFamily: 'helvetica-neue-bold,Helvetica Neue,Helvetica,Arial,sans-serif',
    },
    body1: {
        fontSize: '1.3rem',
        letterSpacing: '0.01071em',
        fontFamily: 'helvetica-neue,Helvetica Neue,Helvetica,Arial,sans-serif',
    },
    body2: {
        fontSize: '1rem',
        fontFamily: 'helvetica-neue,Helvetica Neue,Helvetica,Arial,sans-serif',
    },
    subtitle1: {
        fontSize: '1.5rem',
        fontFamily: 'helvetica-neue,Helvetica Neue,Helvetica,Arial,sans-serif',
    },
    paragraph: {
        fontsize: '1.4rem',
        fontFamily: 'helvetica-neue,Helvetica Neue,Helvetica,Arial,sans-serif',
    },
    colorError: {
        color: 'rgb(216, 17, 24)',
    },
};
